/* eslint-disable max-len */
import * as React from 'react';
import Svg, { SvgProps, G, Path, Mask, Rect } from 'react-native-svg';

export function SpanishFlagSvg(props: SvgProps) {
  return (
    <Svg
      width={24}
      height={18}
      viewBox="0 0 24 18"
      fill="none"
      {...props}
    >
      <Mask id="mask0_634_26179" x={0} y={0} width={24} height={18}>
        <Rect width={24} height={18} fill="white" />
      </Mask>
      <G mask="url(#mask0_634_26179)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 0H24V18H6V0Z"
          fill="#EF0000"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H9V18H0V0Z"
          fill="#2F8D00"
        />
        <Mask id="mask1_634_26179" x={3} y={3} width={12} height={12}>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.92829 14.8554C5.73293 14.8554 3.14258 12.2338 3.14258 8.99995C3.14258 5.76609 5.73293 3.14453 8.92829 3.14453C12.1237 3.14453 14.714 5.76609 14.714 8.99995C14.714 12.2338 12.1237 14.8554 8.92829 14.8554Z"
            fill="white"
          />
        </Mask>
        <G mask="url(#mask1_634_26179)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57031 3H9.32031V5.0241H8.57031V3Z"
            fill="#FFE017"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57031 13.1211H9.32031V15.0006H8.57031V13.1211Z"
            fill="#FFE017"
          />
          <Path
            d="M3.23508 9.30204L3.02539 8.76407C5.33928 7.84031 7.0857 7.24458 8.27069 6.9761C10.0093 6.58219 11.9196 6.29075 14.0017 6.10156L14.0528 6.67756C11.9946 6.86458 10.1088 7.15228 8.39553 7.54044C7.24581 7.80093 5.52365 8.38839 3.23508 9.30204Z"
            fill="#FFE017"
          />
          <Path
            d="M14.3553 5.74733L14.1851 6.29941C12.4363 5.74733 11.0117 5.51001 9.91672 5.58352L9.87891 5.00647C11.0546 4.92755 12.5449 5.17582 14.3553 5.74733Z"
            fill="#FFE017"
          />
          <Path
            d="M14.9597 8.83597L14.6365 9.31285C13.745 8.6939 12.6466 8.383 11.334 8.383V7.80469C12.757 7.80469 13.9681 8.1475 14.9597 8.83597Z"
            fill="#FFE017"
          />
          <Path
            d="M14.4767 9.00781L14.6244 9.56646C12.7025 10.0871 10.898 10.3824 9.21091 10.452C7.5122 10.522 5.5323 10.2256 3.26953 9.56496L3.42792 9.00931C5.63569 9.65389 7.55617 9.94142 9.18766 9.87415C10.8308 9.80641 12.5938 9.51782 14.4767 9.00781Z"
            fill="#FFE017"
          />
          <Path
            d="M14.2579 11.7251L13.3547 12.6511C11.6382 10.9362 10.127 9.70995 8.83039 8.97317C7.51166 8.22381 5.79192 7.46288 3.67383 6.69345L4.10819 5.46875C6.28874 6.26087 8.07174 7.04979 9.45986 7.83858C10.8701 8.63997 12.4664 9.93522 14.2579 11.7251Z"
            fill="#FFE017"
          />
          <Path
            d="M4.09385 12.2496L3.75195 11.7862C3.7997 11.7501 3.88489 11.6899 4.00226 11.6137C4.19606 11.4878 4.41127 11.3621 4.64281 11.2446C5.28054 10.9211 5.92024 10.7191 6.53038 10.7006C6.56022 10.6997 6.58993 10.6992 6.61952 10.6992V11.2775C6.59568 11.2775 6.57169 11.2779 6.54754 11.2786C6.03336 11.2943 5.46871 11.4726 4.89887 11.7616C4.68647 11.8694 4.48856 11.985 4.31095 12.1004C4.24913 12.1405 4.19443 12.1777 4.14756 12.2108C4.12023 12.2301 4.10209 12.2433 4.09385 12.2496Z"
            fill="#FFE017"
          />
          <Path
            d="M4.35938 12.4525L4.50328 11.8928C6.40837 12.3946 7.87708 12.6446 8.9021 12.6446C9.92328 12.6446 11.4432 12.3497 13.4521 11.7578L13.6118 12.3131C11.5554 12.9189 9.98884 13.2229 8.9021 13.2229C7.81919 13.2229 6.30739 12.9655 4.35938 12.4525Z"
            fill="#FFE017"
          />
          <Path
            d="M3.61719 7.27161L4.52249 6.34766L5.84799 7.67789L4.94268 8.60184L3.61719 7.27161Z"
            fill="#FFE017"
          />
          <Path
            d="M11.127 11.8858L11.8003 10.7773L13.9031 12.0857L13.2297 13.1942L11.127 11.8858Z"
            fill="#FFE017"
          />
        </G>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.14258 8.99995C3.14258 12.2338 5.73293 14.8554 8.92829 14.8554C12.1237 14.8554 14.714 12.2338 14.714 8.99995C14.714 5.76609 12.1237 3.14453 8.92829 3.14453C5.73293 3.14453 3.14258 5.76609 3.14258 8.99995ZM13.9997 9.07224C13.9997 11.8669 11.7611 14.1325 8.99971 14.1325C6.23828 14.1325 3.99971 11.8669 3.99971 9.07224C3.99971 6.27755 6.23828 4.012 8.99971 4.012C11.7611 4.012 13.9997 6.27755 13.9997 9.07224Z"
          fill="#F9E813"
        />
        <Path
          d="M5.74219 5.39062V10.0862C6.05129 11.9447 7.09264 12.874 8.86623 12.874C10.6398 12.874 11.6812 11.9447 11.9903 10.0862V5.39062H5.74219Z"
          fill="white"
        />
        <Path
          d="M5.31445 4.95703H12.4197V10.1225L12.4137 10.1583C12.0705 12.222 10.8537 13.3079 8.86707 13.3079C6.8804 13.3079 5.66363 12.222 5.3204 10.1583L5.31445 10.1225V4.95703Z"
          fill="#C51918"
        />
        <Path
          d="M6.93945 6.53516H10.7942V9.86583C10.7942 9.86583 10.5082 11.5858 8.86685 11.5858C7.22551 11.5858 6.93945 9.86583 6.93945 9.86583V6.53516Z"
          fill="#F7FCFF"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 5.31641H6.54217V5.67785H6V5.31641Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 5.46094H6.71484V5.64166H5.71484V5.46094Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 5.60547H6.25701V5.78619H5.71484V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.28516 5.60547H6.82732V5.78619H6.28516V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 6.03906H6.07629V6.58123H5.71484V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.42969 6.03906H6.79113V6.58123H6.42969V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.14258 6.03906H6.3233V6.58123H6.14258V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 5.89453H6.71484V6.07525H5.71484V5.89453Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 6.32812H6.71484V6.50885H5.71484V6.32812Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.85742 5.75H6.03814V5.93072H5.85742V5.75Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.42969 5.75H6.61041V5.93072H6.42969V5.75Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.14258 5.60547H6.3233V5.96691H6.14258V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.71484 5.31641H9.25701V5.67785H8.71484V5.31641Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.42969 5.46094H9.42969V5.64166H8.42969V5.46094Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.42969 5.60547H8.97186V5.78619H8.42969V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 5.60547H9.54217V5.78619H9V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.42969 6.03906H8.79113V6.58123H8.42969V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.14453 6.03906H9.50598V6.58123H9.14453V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.85742 6.03906H9.03814V6.58123H8.85742V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.42969 5.89453H9.42969V6.07525H8.42969V5.89453Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.42969 6.32812H9.42969V6.50885H8.42969V6.32812Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.57227 5.75H8.75299V5.93072H8.57227V5.75Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.14453 5.75H9.32525V5.93072H9.14453V5.75Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.85742 5.60547H9.03814V5.96691H8.85742V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2852 5.31641H11.8273V5.67785H11.2852V5.31641Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5.46094H12V5.64166H11V5.46094Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5.60547H11.5422V5.78619H11V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5723 5.60547H12.1144V5.78619H11.5723V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 6.03906H11.3614V6.58123H11V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7148 6.03906H12.0763V6.58123H11.7148V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4297 6.03906H11.6104V6.58123H11.4297V6.03906Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 5.89453H12V6.07525H11V5.89453Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 6.32812H12V6.50885H11V6.32812Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1426 5.75H11.3233V5.93072H11.1426V5.75Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7148 5.75H11.8956V5.93072H11.7148V5.75Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4297 5.60547H11.6104V5.96691H11.4297V5.60547Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2852 7.91797H11.8273V8.27941H11.2852V7.91797Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 8.0625H12V8.24322H11V8.0625Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 8.20703H11.5422V8.38775H11V8.20703Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5723 8.20703H12.1144V8.38775H11.5723V8.20703Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 8.64062H11.3614V9.18279H11V8.64062Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7148 8.64062H12.0763V9.18279H11.7148V8.64062Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4297 8.64062H11.6104V9.18279H11.4297V8.64062Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 8.49609H12V8.67682H11V8.49609Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 8.92969H12V9.11041H11V8.92969Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1426 8.35156H11.3233V8.53229H11.1426V8.35156Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7148 8.35156H11.8956V8.53229H11.7148V8.35156Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4297 8.20703H11.6104V8.56848H11.4297V8.20703Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 7.91797H6.54217V8.27941H6V7.91797Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 8.0625H6.71484V8.24322H5.71484V8.0625Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 8.20703H6.25701V8.38775H5.71484V8.20703Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.28516 8.20703H6.82732V8.38775H6.28516V8.20703Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 8.64062H6.07629V9.18279H5.71484V8.64062Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.42969 8.64062H6.79113V9.18279H6.42969V8.64062Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.14258 8.64062H6.3233V9.18279H6.14258V8.64062Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 8.49609H6.71484V8.67682H5.71484V8.49609Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.71484 8.92969H6.71484V9.11041H5.71484V8.92969Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.85742 8.35156H6.03814V8.53229H5.85742V8.35156Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.42969 8.35156H6.61041V8.53229H6.42969V8.35156Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.14258 8.20703H6.3233V8.56848H6.14258V8.20703Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.34766 11.1797L6.69616 10.7644L6.97304 10.9967L6.62454 11.412L6.34766 11.1797Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.27539 11.4922L6.91818 10.7261L7.05662 10.8423L6.41383 11.6084L6.27539 11.4922Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.38477 11.5859L6.73326 11.1706L6.87171 11.2868L6.52321 11.7021L6.38477 11.5859Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.75391 11.1484L7.10241 10.7331L7.24085 10.8493L6.89235 11.2646L6.75391 11.1484Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.71875 11.8633L6.95108 11.5864L7.36641 11.9349L7.13408 12.2118L6.71875 11.8633Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.17773 11.3164L7.41007 11.0395L7.82539 11.388L7.59306 11.6649L7.17773 11.3164Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.99414 11.5352L7.11031 11.3967L7.52563 11.7452L7.40947 11.8837L6.99414 11.5352Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.60742 11.7695L7.25021 11.0035L7.38865 11.1197L6.74586 11.8857L6.60742 11.7695Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.93945 12.0508L7.58224 11.2847L7.72068 11.4009L7.07789 12.1669L6.93945 12.0508Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.58789 11.5664L6.70406 11.428L6.8425 11.5441L6.72633 11.6826L6.58789 11.5664Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.95508 11.1289L7.07124 10.9905L7.20969 11.1066L7.09352 11.2451L6.95508 11.1289Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.66016 11.2578L6.77632 11.1194L7.05321 11.3517L6.93704 11.4901L6.66016 11.2578Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2344 10.8516L11.5829 11.2669L11.306 11.4992L10.9575 11.0839L11.2344 10.8516Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9395 10.7266L11.5822 11.4926L11.4438 11.6088L10.801 10.8427L10.9395 10.7266Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8301 10.8203L11.1786 11.2356L11.0401 11.3518L10.6916 10.9365L10.8301 10.8203Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1973 11.2578L11.5458 11.6731L11.4073 11.7893L11.0588 11.374L11.1973 11.2578Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4961 11.0977L10.7284 11.3745L10.3131 11.723L10.0808 11.4462L10.4961 11.0977Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.957 11.6445L11.1894 11.9214L10.774 12.2699L10.5417 11.993L10.957 11.6445Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7715 11.4258L10.8877 11.5642L10.4723 11.9127L10.3562 11.7743L10.7715 11.4258Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6074 11.0039L11.2502 11.77L11.1118 11.8861L10.469 11.1201L10.6074 11.0039Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2754 11.2852L10.9182 12.0512L10.7797 12.1674L10.1369 11.4013L10.2754 11.2852Z"
          fill="white"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8105 11.0195L10.9267 11.158L10.7883 11.2741L10.6721 11.1357L10.8105 11.0195Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1777 11.457L11.2939 11.5955L11.1555 11.7116L11.0393 11.5732L11.1777 11.457Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1055 11.1484L11.2216 11.2869L10.9448 11.5192L10.8286 11.3808L11.1055 11.1484Z"
          fill="#F9E813"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41994 6.90625H8.42969V7.62735C8.42969 7.62735 8.50317 7.99974 8.92481 7.99974C9.34645 7.99974 9.41994 7.62735 9.41994 7.62735V6.90625ZM8.85837 7.1954C8.85837 7.27525 8.79441 7.33998 8.71551 7.33998C8.63662 7.33998 8.57266 7.27525 8.57266 7.1954C8.57266 7.11555 8.63662 7.05082 8.71551 7.05082C8.79441 7.05082 8.85837 7.11555 8.85837 7.1954ZM8.71551 7.9183C8.79441 7.9183 8.85837 7.85357 8.85837 7.77372C8.85837 7.69387 8.79441 7.62914 8.71551 7.62914C8.63662 7.62914 8.57266 7.69387 8.57266 7.77372C8.57266 7.85357 8.63662 7.9183 8.71551 7.9183ZM9.28669 7.77372C9.28669 7.85357 9.22273 7.9183 9.14383 7.9183C9.06494 7.9183 9.00098 7.85357 9.00098 7.77372C9.00098 7.69387 9.06494 7.62914 9.14383 7.62914C9.22273 7.62914 9.28669 7.69387 9.28669 7.77372ZM8.92967 7.62914C9.00857 7.62914 9.07253 7.56441 9.07253 7.48456C9.07253 7.40471 9.00857 7.33998 8.92967 7.33998C8.85078 7.33998 8.78682 7.40471 8.78682 7.48456C8.78682 7.56441 8.85078 7.62914 8.92967 7.62914ZM9.28669 7.1954C9.28669 7.27525 9.22273 7.33998 9.14383 7.33998C9.06494 7.33998 9.00098 7.27525 9.00098 7.1954C9.00098 7.11555 9.06494 7.05082 9.14383 7.05082C9.22273 7.05082 9.28669 7.11555 9.28669 7.1954Z"
          fill="#013399"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41994 8.49609H8.42969V9.2172C8.42969 9.2172 8.50317 9.58958 8.92481 9.58958C9.34645 9.58958 9.41994 9.2172 9.41994 9.2172V8.49609ZM8.85837 8.78526C8.85837 8.86511 8.79441 8.92984 8.71551 8.92984C8.63662 8.92984 8.57266 8.86511 8.57266 8.78526C8.57266 8.70542 8.63662 8.64069 8.71551 8.64069C8.79441 8.64069 8.85837 8.70542 8.85837 8.78526ZM8.71551 9.50816C8.79441 9.50816 8.85837 9.44343 8.85837 9.36358C8.85837 9.28374 8.79441 9.21901 8.71551 9.21901C8.63662 9.21901 8.57266 9.28374 8.57266 9.36358C8.57266 9.44343 8.63662 9.50816 8.71551 9.50816ZM9.28669 9.36358C9.28669 9.44343 9.22273 9.50816 9.14383 9.50816C9.06494 9.50816 9.00098 9.44343 9.00098 9.36358C9.00098 9.28374 9.06494 9.21901 9.14383 9.21901C9.22273 9.21901 9.28669 9.28374 9.28669 9.36358ZM8.92967 9.219C9.00857 9.219 9.07253 9.15427 9.07253 9.07442C9.07253 8.99458 9.00857 8.92985 8.92967 8.92985C8.85078 8.92985 8.78682 8.99458 8.78682 9.07442C8.78682 9.15427 8.85078 9.219 8.92967 9.219ZM9.28669 8.78526C9.28669 8.86511 9.22273 8.92984 9.14383 8.92984C9.06494 8.92984 9.00098 8.86511 9.00098 8.78526C9.00098 8.70542 9.06494 8.64069 9.14383 8.64069C9.22273 8.64069 9.28669 8.70542 9.28669 8.78526Z"
          fill="#013399"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7051 8.49609H9.71484V9.2172C9.71484 9.2172 9.78833 9.58958 10.21 9.58958C10.6316 9.58958 10.7051 9.2172 10.7051 9.2172V8.49609ZM10.1435 8.78526C10.1435 8.86511 10.0795 8.92984 10.0006 8.92984C9.92172 8.92984 9.85776 8.86511 9.85776 8.78526C9.85776 8.70542 9.92172 8.64069 10.0006 8.64069C10.0795 8.64069 10.1435 8.70542 10.1435 8.78526ZM10.0006 9.50816C10.0795 9.50816 10.1435 9.44343 10.1435 9.36358C10.1435 9.28374 10.0795 9.21901 10.0006 9.21901C9.92172 9.21901 9.85776 9.28374 9.85776 9.36358C9.85776 9.44343 9.92172 9.50816 10.0006 9.50816ZM10.5718 9.36358C10.5718 9.44343 10.5078 9.50816 10.4289 9.50816C10.35 9.50816 10.2861 9.44343 10.2861 9.36358C10.2861 9.28374 10.35 9.21901 10.4289 9.21901C10.5078 9.21901 10.5718 9.28374 10.5718 9.36358ZM10.2148 9.219C10.2937 9.219 10.3576 9.15427 10.3576 9.07442C10.3576 8.99458 10.2937 8.92985 10.2148 8.92985C10.1359 8.92985 10.0719 8.99458 10.0719 9.07442C10.0719 9.15427 10.1359 9.219 10.2148 9.219ZM10.5718 8.78526C10.5718 8.86511 10.5078 8.92984 10.4289 8.92984C10.35 8.92984 10.2861 8.86511 10.2861 8.78526C10.2861 8.70542 10.35 8.64069 10.4289 8.64069C10.5078 8.64069 10.5718 8.70542 10.5718 8.78526Z"
          fill="#013399"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.13283 8.49609H7.14258V9.2172C7.14258 9.2172 7.21606 9.58958 7.6377 9.58958C8.05934 9.58958 8.13283 9.2172 8.13283 9.2172V8.49609ZM7.57136 8.78526C7.57136 8.86511 7.5074 8.92984 7.4285 8.92984C7.3496 8.92984 7.28564 8.86511 7.28564 8.78526C7.28564 8.70542 7.3496 8.64069 7.4285 8.64069C7.5074 8.64069 7.57136 8.70542 7.57136 8.78526ZM7.4285 9.50816C7.5074 9.50816 7.57136 9.44343 7.57136 9.36358C7.57136 9.28374 7.5074 9.21901 7.4285 9.21901C7.3496 9.21901 7.28564 9.28374 7.28564 9.36358C7.28564 9.44343 7.3496 9.50816 7.4285 9.50816ZM7.99968 9.36358C7.99968 9.44343 7.93572 9.50816 7.85682 9.50816C7.77792 9.50816 7.71396 9.44343 7.71396 9.36358C7.71396 9.28374 7.77792 9.21901 7.85682 9.21901C7.93572 9.21901 7.99968 9.28374 7.99968 9.36358ZM7.64266 9.219C7.72156 9.219 7.78552 9.15427 7.78552 9.07442C7.78552 8.99458 7.72156 8.92985 7.64266 8.92985C7.56376 8.92985 7.4998 8.99458 7.4998 9.07442C7.4998 9.15427 7.56376 9.219 7.64266 9.219ZM7.99968 8.78526C7.99968 8.86511 7.93572 8.92984 7.85682 8.92984C7.77792 8.92984 7.71396 8.86511 7.71396 8.78526C7.71396 8.70542 7.77792 8.64069 7.85682 8.64069C7.93572 8.64069 7.99968 8.70542 7.99968 8.78526Z"
          fill="#013399"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.41994 10.0859H8.42969V10.807C8.42969 10.807 8.50317 11.1794 8.92481 11.1794C9.34645 11.1794 9.41994 10.807 9.41994 10.807V10.0859ZM8.85837 10.3751C8.85837 10.4549 8.79441 10.5197 8.71551 10.5197C8.63662 10.5197 8.57266 10.4549 8.57266 10.3751C8.57266 10.2952 8.63662 10.2305 8.71551 10.2305C8.79441 10.2305 8.85837 10.2952 8.85837 10.3751ZM8.71551 11.098C8.79441 11.098 8.85837 11.0333 8.85837 10.9534C8.85837 10.8736 8.79441 10.8088 8.71551 10.8088C8.63662 10.8088 8.57266 10.8736 8.57266 10.9534C8.57266 11.0333 8.63662 11.098 8.71551 11.098ZM9.28669 10.9534C9.28669 11.0333 9.22273 11.098 9.14383 11.098C9.06494 11.098 9.00098 11.0333 9.00098 10.9534C9.00098 10.8736 9.06494 10.8088 9.14383 10.8088C9.22273 10.8088 9.28669 10.8736 9.28669 10.9534ZM8.92967 10.8088C9.00857 10.8088 9.07253 10.7441 9.07253 10.6642C9.07253 10.5844 9.00857 10.5197 8.92967 10.5197C8.85078 10.5197 8.78682 10.5844 8.78682 10.6642C8.78682 10.7441 8.85078 10.8088 8.92967 10.8088ZM9.28669 10.3751C9.28669 10.4549 9.22273 10.5197 9.14383 10.5197C9.06494 10.5197 9.00098 10.4549 9.00098 10.3751C9.00098 10.2952 9.06494 10.2305 9.14383 10.2305C9.22273 10.2305 9.28669 10.2952 9.28669 10.3751Z"
          fill="#013399"
        />
      </G>
    </Svg>
  );
}
